import { Box, Flex } from "@chakra-ui/react"
import { FormProvider, useForm } from "react-hook-form"
import { Header } from "../../components/Header"
import { ContaCorrente } from "./ContaCorrente"
import { Movimentos } from "./Movimentos"

export function Movimentacao(){
    const form = useForm()
    
      return (
        <FormProvider {...form}>
          <Box
            display={"flex"}
            flexDir={"column"}
            justifyContent={"center"}
            width={"full"}
            alignItems={"center"}
          >
            <Flex
              maxWidth={"90%"}
              width={"100%"}
              flexDir={"column"}
              justifyContent={"center"}
            >
              <Header />
              <Box
                px={"1rem"}
                bg={"white"}
                w={"full"}
                display={"flex"}
                flexDir={"column"}
                gap={"8"}
                pb={8}
              >
                <ContaCorrente />
                <Movimentos />
              </Box>
            </Flex>
          </Box>
        </FormProvider>
  )
}